import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Alerts from './pages/Alerts';
import Products from './pages/Products';
import Resources from './pages/Resources';
import About from './pages/About';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-background font-sans text-gray-900">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/products" element={<Products />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;